module.exports = __webpack_public_path__ + "static/media/outside.e3a1b07b.png";